<template>
    <ac-modal :size="'modal-lg'" ref="modal" :title="'Coverage Map'">
        <template>
            <div id="map-container">
                <div ref="map" id="map" style="width: 100%; height:700px;"></div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {mapUtilities} from "../../../../components/shared/scripts/map/mapUtilities.js";

    export default {
        name: "GeoAnalysisMapModal",
        data() {
            return {
                map: null,
                addresses: [],
                physicianLocations: []
            }
        },
        methods: {
            async showModal(inputId) {
                let [inputs, physicians] = await Promise.all([
                    api.get('GeoAnalysisReport', inputId, 'GetBatchRecords'),
                    api.get('GeoAnalysisReport', inputId, 'GetPhysicianLocations')
                ]);
                this.addresses = inputs;
                this.physicianLocations = physicians;
                this.$refs.modal.open();
                await this.$nextTick();
                await mapUtilities.initMap(this.$refs.map, this.onMapsLoaded);
            },
            async onMapsLoaded(map, googleMapsObject) {
                this.map = map;
                await mapUtilities.initMarkers(this.map, googleMapsObject, this.addresses);
                await mapUtilities.initClusters(this.map, googleMapsObject, this.physicianLocations);
            }
        }
    }
</script>

<style scoped>

</style>